var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7832 25.9837C10.2428 23.9428 13.0801 21.6904 15.2952 19.2264C17.5103 16.7624 18.6179 14.3855 18.6179 12.0957C18.6179 10.8762 18.2321 9.90549 17.4605 9.18372C16.7139 8.43705 15.6561 8.06372 14.2872 8.06372C12.993 8.06372 11.8979 8.31261 11.0019 8.81038C10.1308 9.28327 9.27209 9.90549 8.42587 10.6771L7.0072 8.62372C7.50498 8.00149 8.21431 7.36683 9.1352 6.71972C10.081 6.07261 11.1761 5.53749 12.4205 5.11438C13.665 4.66638 14.9219 4.44238 16.1912 4.44238C18.0081 4.44238 19.5263 4.75349 20.7459 5.37572C21.9903 5.99794 22.9112 6.81927 23.5085 7.83972C24.1059 8.86016 24.4045 9.99261 24.4045 11.2371C24.4045 13.6264 23.2596 16.0282 20.9699 18.4424C18.6801 20.8566 15.7681 23.0717 12.2339 25.0877L23.0605 24.0797L24.4792 20.9437L26.8312 21.4291L25.7485 27.9997H7.5672L6.7832 25.9837Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.c793d986fa88fc3b2cd1fe8ab17014ec.svg";
export { ForwardRef as ReactComponent };